import React from 'react';

/**
 * 스마트 페이지네이션: 현재 ±2 범위 + 처음/끝 + 생략(...)
 * 예: < 1 ... 4 5 [6] 7 8 ... 20 >
 */
export default function Pagination({ page, totalPages, onPageChange, className = 'pub-pagination' }) {
  if (totalPages <= 1) return null;

  const delta = 2;
  const rangeStart = Math.max(0, page - delta);
  const rangeEnd = Math.min(totalPages - 1, page + delta);

  const pages = [];
  for (let i = rangeStart; i <= rangeEnd; i++) pages.push(i);

  // 처음 페이지 추가
  const showFirstDot = rangeStart > 1;
  const showFirst = rangeStart > 0;
  // 끝 페이지 추가
  const showLastDot = rangeEnd < totalPages - 2;
  const showLast = rangeEnd < totalPages - 1;

  return (
    <div className={className}>
      <button onClick={() => onPageChange(page - 1)} disabled={page === 0}>이전</button>

      {showFirst && (
        <button onClick={() => onPageChange(0)} className={0 === page ? 'active' : ''}>1</button>
      )}
      {showFirstDot && <span className="page-ellipsis">...</span>}

      {pages.map((p) => (
        <button key={p} onClick={() => onPageChange(p)} className={p === page ? 'active' : ''}>
          {p + 1}
        </button>
      ))}

      {showLastDot && <span className="page-ellipsis">...</span>}
      {showLast && (
        <button onClick={() => onPageChange(totalPages - 1)} className={totalPages - 1 === page ? 'active' : ''}>
          {totalPages}
        </button>
      )}

      <button onClick={() => onPageChange(page + 1)} disabled={page >= totalPages - 1}>다음</button>
    </div>
  );
}
